/* ===== JUICY MARBLES CUSTOM JS ===== */

// ===== ALWAYS STICKY HEADER =====
// Override the scroll behavior to keep sticky header always visible
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('main-header[data-sticky-header]');
  
  if (header && header.SCROLL_StickyHelper) {
    // Remove the original scroll listener
    window.removeEventListener('scroll', header.SCROLL_StickyHelper);
    
    // Replace with our always-show version
    window.addEventListener('scroll', function() {
      const stickyHeader = document.querySelector('.sticky-header');
      const originalHeader = document.querySelector('main-header[data-sticky-header]');
      
      if (stickyHeader && originalHeader) {
        // Get the bottom position of the original header
        const headerBottom = originalHeader.getBoundingClientRect().bottom;
        
        // Show sticky header once we've scrolled past the original
        if (headerBottom <= 0) {
          stickyHeader.classList.add('show');
        } else {
          stickyHeader.classList.remove('show');
        }
      }
    }, {passive: true});
  }
});